export default __webpack_public_path__ + "static/media/H1008.2.d69b9b27.mp3";